import "./App.css";
import Search from "./Search";

function App() {
  return (
    <div className="App">
      <Search name="DICTIONNARY" />
    </div>
  );
}

export default App;
